'use strict';

/**
 * Area Chooser sticky behavior
 * When the search form scrolls out of view, it becomes fixed at the top (desktop)
 * or bottom (mobile).
 * On mobile, when the footer is in view, the bottom offset is adjusted
 * to keep the sticky bar above the footer.
 *
 * Uses IntersectionObserver for reliable detection.
 */
(function() {
    var MOBILE_BREAKPOINT = '(max-width: 767px)';

    function getVisibleContainer() {
        var containers = document.querySelectorAll('.area-chooser-form__container-onscroll');
        for (var i = 0; i < containers.length; i++) {
            if (containers[i].offsetParent !== null || containers[i].offsetWidth > 0) {
                return containers[i];
            }
        }
        return containers[0] || null;
    }

    /**
     * Mobile/WebKit can fail to navigate when the compare button lives in a fixed
     * sticky bar (.area-chooser-form__container--sticky). Programmatic
     * requestSubmit matches the behaviour used on product-chooser sticky CTAs.
     */
    function bindStickySubmitWorkaround(container) {
        var form = container.querySelector('.area-chooser-form');
        var btn = form && form.querySelector('button[type="submit"]');
        if (!form || !btn || btn.dataset.areaChooserStickySubmitBound) {
            return;
        }
        btn.dataset.areaChooserStickySubmitBound = 'true';
        btn.addEventListener('click', function(e) {
            if (form.dataset.sticky !== 'true') {
                return;
            }
            e.preventDefault();
            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit(btn);
            } else {
                form.submit();
            }
        });
    }

    function init() {
        var container = getVisibleContainer();
        if (!container) return;

        bindStickySubmitWorkaround(container);

        var placeholder = document.createElement('div');
        placeholder.style.display = 'none';
        container.parentNode.insertBefore(placeholder, container);

        var isSticky = false;
        var isMobile = window.matchMedia(MOBILE_BREAKPOINT);
        var footer = document.querySelector('.c24-footer');

        function makeSticky() {
            if (isSticky) return;
            placeholder.style.display = 'block';
            placeholder.style.height = container.offsetHeight + 'px';
            container.classList.add('area-chooser-form__container--sticky');
            let form = container.querySelector('.area-chooser-form');
            form.dataset.sticky = 'true';
            isSticky = true;
        }

        function makeUnsticky() {
            if (!isSticky) return;
            container.classList.remove('area-chooser-form__container--sticky');
            let form = container.querySelector('.area-chooser-form');
            form.dataset.sticky = 'false';
            container.style.bottom = '';
            placeholder.style.display = 'none';
            placeholder.style.height = '0';
            isSticky = false;
        }

        function adjustForFooter() {
            if (!isSticky || !footer || !isMobile.matches) {
                container.style.bottom = '';
                return;
            }

            var footerTop = footer.getBoundingClientRect().top;
            var viewportHeight = window.innerHeight;

            if (footerTop < viewportHeight) {
                // container.style.bottom = (viewportHeight - footerTop) + 'px';
            } else {
                container.style.bottom = '';
            }
        }
        const dataOutput = 'main';
        document.querySelectorAll('.area-chooser-form').forEach(function(form) {
            form.dataset.output = dataOutput;
        });

        var sentinel = document.createElement('div');
        sentinel.style.height = '1px';
        sentinel.style.marginBottom = '-1px';
        sentinel.style.pointerEvents = 'none';
        container.parentNode.insertBefore(sentinel, placeholder);

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                        makeSticky();
                        adjustForFooter();
                    } else if (entry.isIntersecting) {
                        makeUnsticky();
                    }
                });
            }, { threshold: 0 });
            observer.observe(sentinel);

            window.addEventListener('scroll', function() {
                if (isSticky) adjustForFooter();
            }, { passive: true });
        } else {
            function onScroll() {
                if (sentinel.getBoundingClientRect().top < 0) {
                    makeSticky();
                    adjustForFooter();
                } else {
                    makeUnsticky();
                }
            }
            window.addEventListener('scroll', onScroll, { passive: true });
            document.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
